import React from 'react'
import DefaultLayout from '../layout/DefaultLayout'

const PlayPage = () => {
  return (
    <div>PlayPage</div>
  )
}

export default DefaultLayout(PlayPage) 